import { useTableDataQuery } from '@/modules/common';

import { SystemPromptResponse } from '../types';

export function usePromptsByCategory(categoryId: string) {
  return useTableDataQuery<SystemPromptResponse>({
    url: `/system-prompts/categories/${categoryId}/prompts`,
    baseQueryKey: ['prompts-by-category', categoryId],
    persistState: false,
  });
}
